import { CardStatus } from '@xt/ui-kit';
import {
  CardConfig,
  CardIdentifier,
  PersonRowsTypes,
  FacilityRowsTypes,
  StationSectionTypes,
  RolesRowsTypes,
  MedicalInfoTypes,
} from '@xt/verification-cdk';

// Curamenta has specific identificaiton role for providers - professional,
// and cardId mapping is built based on identificationTypes in cards-list.component on PPP
export const professionalCardId = 'professionalPersonData' as CardIdentifier;

// Note! order in this config does matter on IDVS flow
// If you need to force sorting on some roles specific IDVS steps,
// please use sortingOrder option in cardsConfig
// Example: PROVIDER_VERIFICATION_CARDS_SORTING

export const CardsConfig: CardConfig[] = [
  {
    title: 'app.verification.representative',
    icon: 'supervised_user_circle',
    status: CardStatus.None,
    id: CardIdentifier.representativePersonData,
    rows: [
      PersonRowsTypes.basic,
      PersonRowsTypes.address,
      PersonRowsTypes.phone,
    ],
  },
  {
    title: 'app.identification.cards.person',
    icon: 'account_circle',
    id: CardIdentifier.representedPersonData,
    status: CardStatus.None,
    rows: [
      PersonRowsTypes.basic,
      PersonRowsTypes.address,
      PersonRowsTypes.phone,
    ],
  },
  {
    title: 'app.identification.cards.facility',
    icon: 'apartment',
    status: CardStatus.None,
    id: CardIdentifier.selectedFacility,
    rows: [FacilityRowsTypes.name, FacilityRowsTypes.address],
  },
  {
    title: 'app.identification.cards.person',
    icon: 'person',
    id: CardIdentifier.patientPersonData,
    status: CardStatus.None,
    rows: [
      PersonRowsTypes.basic,
      PersonRowsTypes.address,
      PersonRowsTypes.phone,
    ],
  },
  {
    title: 'app.identification.cards.station',
    icon: 'home_health',
    id: CardIdentifier.selectedStation,
    status: CardStatus.None,
    sections: StationSectionTypes.multipleStations, // use sections instead of rows
  },
  {
    title: 'app.identification.cards.userRole',
    icon: 'account_tree',
    status: CardStatus.None,
    id: CardIdentifier.rolesData,
    rows: [RolesRowsTypes.role],
  },
  {
    title: 'app.identification.cards.person',
    icon: 'person',
    id: professionalCardId,
    status: CardStatus.None,
    rows: [
      PersonRowsTypes.basic,
      PersonRowsTypes.address,
      PersonRowsTypes.phone,
    ],
  },
  {
    title: 'app.identification.cards.medicalInfo',
    icon: 'create_new_folder',
    status: CardStatus.None,
    id: CardIdentifier.providerMedicalData,
    rows: [
      MedicalInfoTypes.lifetimeDoctorNumber,
      MedicalInfoTypes.specialty,
      MedicalInfoTypes.profession,
    ],
  },
];

export const PROVIDER_VERIFICATION_CARDS_SORTING = [
  professionalCardId,
  CardIdentifier.selectedFacility,
  CardIdentifier.selectedStation,
  CardIdentifier.rolesData,
  CardIdentifier.providerMedicalData,
];
